import { lazyWithPreload } from 'helpers/lazyWithPreload'

export const PreferredFood = lazyWithPreload(() => import('./PreferredFood'))
